import { render } from "./UserManagement.vue?vue&type=template&id=4f6dc8ba&scoped=true"
import script from "./UserManagement.vue?vue&type=script&lang=js"
export * from "./UserManagement.vue?vue&type=script&lang=js"

import "./UserManagement.vue?vue&type=style&index=0&id=4f6dc8ba&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6dc8ba"]])

export default __exports__